console.log('LOADED: cookies');

// 'regenerator-runtime/runtime' is required to Cookies module
import 'regenerator-runtime/runtime'
import Cookies from 'efile-ui/src/js/modules/cookies/cookies';

if (typeof COOKIE_NAME === 'undefined') {
    console.log('NOT LOADED: cookies');
} else {
    console.log('LOADED: cookies');

    (function () {
        const cookies = new Cookies(COOKIE_NAME, COOKIE_PATH);
        // cookies.checkCookie();
        cookies.initialize();
    })();
}



